import React, {useEffect} from 'react';
import c from 'classnames';
import {useSwipeable} from 'react-swipeable';
import Modal from './Modal';
import {getCaptionFromPictureMeta} from '../helpers';
import styles from './styles/ArtPieceModal.module.scss';
import arrowIcon from '../img/arrow-right.svg';

const ArtPieceModal = ({image, meta, onRequestClose, onRequestNext, onRequestPrev}) => {
    useEffect(() => {
        const handler = (event) => {
            if (event.code === 'ArrowLeft') {
                onRequestPrev();
            } else if (event.code === 'ArrowRight') {
                onRequestNext();
            }
        };

        window.addEventListener('keydown', handler);

        return () => {
            window.removeEventListener('keydown', handler);
        };
    }, [onRequestNext, onRequestPrev]);

    const swipeHandlers = useSwipeable({
        onSwipedLeft: () => onRequestNext(),
        onSwipedRight: () => onRequestPrev(),
    });

    return (
        <Modal onRequestClose={onRequestClose}>
            <div className={styles.wrapper}>
                <div className={styles.imageContainer} {...swipeHandlers}>
                    <picture>
                        <source srcSet={image.srcSet} sizes={image.sizes} />
                        <source srcSet={image.srcSetWebp} sizes={image.sizes} />
                        <img src={image.src} className={styles.image} alt="" />
                    </picture>
                    <button className={c(styles.arrow, styles.left)} onClick={onRequestPrev}>
                        <img className={styles.arrowIcon} src={arrowIcon} alt="Previous" />
                    </button>
                    <button className={c(styles.arrow, styles.right)} onClick={onRequestNext}>
                        <img className={styles.arrowIcon} src={arrowIcon} alt="Next" />
                    </button>
                </div>
                <div className={styles.captionContainer}>{getCaptionFromPictureMeta(meta)}</div>
            </div>
        </Modal>
    );
};

export default ArtPieceModal;
